'use strict';

angular.module('clientDashboardApp').controller("OverviewMapCtrl", function ($scope, $state, $location, $log, $q, locationService, reviewService, numberFilter) {

    function loadMapData(groupId) {
        $scope.avgReviewByState = null;
        $scope.currentLocationGroup = null;
        $scope.avgReviewByLocation = null;


        $q.all({
          averages: reviewService.averageReviewByState(groupId),
          group: locationService.loadLocationGroup(groupId)
        }).then(function ({ averages, group }) {
            $scope.avgReviewByState = averages.byState;
            $scope.reviewSummaryByLocation = averages.byLocation;
            var locations = group;

            var addressPoints = [];
            for (var i = 0; i < locations.length; i++) {
                var location = locations[i];
                var newLocation = {};
                newLocation.locationId = location.locationId;
                if (!location.coordinates) {
                    continue;
                }
                newLocation.lat = location.coordinates.coordinates[1];
                newLocation.lng = location.coordinates.coordinates[0];
                var address = location.businessAddress;
                newLocation.state = address.state;
                newLocation.message = '<strong>' + location.businessName + '</strong><br>' + address.street + '<br>' + address.city + ', ' + address.state + ', ' + address.postalCode + '<br>' + address.country + '<br>';

                var reviewSummary = $scope.reviewSummaryByLocation[location.locationId];
                var reviewAvgForLocation = reviewSummary.avgReview;
                var numberOfReviews = reviewSummary.numReviews;

                var avgReviewTxt;
                if (!angular.isDefined(reviewAvgForLocation)) {
                    avgReviewTxt = 'No reviews with Ratings for this location';
                } else {
                    avgReviewTxt = 'Average Rating: ' + Math.round(reviewAvgForLocation * 10) / 10;
                }
                var numReviewTxt = 'Number of Reviews: ' + numberFilter(numberOfReviews);

                newLocation.message += `<a href="/#/reviews?groupId=${location.locationId}">${avgReviewTxt}<br>${numReviewTxt}</a>`;
                addressPoints.push(newLocation);
            }

            $scope.currentLocationGroup = addressPoints;
        });
    }

    $scope.$watch(function () {
        return locationService.getSelectedGroupId();
    }, function (groupId) {
        if (!groupId) {
            //Ignore undefined initial group id
            return;
        }
        //Reload page
        loadMapData(groupId);
    }, true);
});
